
import { storage } from '../lib/storage';
import { StoreStaff, StaffRole, Store } from '../types';

export const staffService = {
  getStoreStaff: (storeId: string): StoreStaff[] => {
    const store = storage.getStoreConfig(storeId);
    return store.staff || [];
  },

  addStaffMember: (storeId: string, email: string, role: StaffRole) => {
    const store = storage.getStoreConfig(storeId);
    const newStaff: StoreStaff = {
      id: 'staff-' + Date.now(),
      email,
      role,
      addedAt: new Date().toISOString(),
      status: 'ACTIVE'
    };
    
    const updatedStaff = [...(store.staff || []), newStaff];
    const updatedStore = { ...store, staff: updatedStaff };
    storage.saveStoreConfig(updatedStore);
    return newStaff;
  },

  removeStaffMember: (storeId: string, staffId: string) => {
    const store = storage.getStoreConfig(storeId);
    const updatedStaff = (store.staff || []).filter(s => s.id !== staffId);
    storage.saveStoreConfig({ ...store, staff: updatedStaff });
  },

  hasPermission: (staffRole: StaffRole | undefined, pageId: string): boolean => {
    if (!staffRole) return true; // Owner has all permissions

    const permissions: Record<StaffRole, string[]> = {
      [StaffRole.MANAGER]: ['admin', 'analytics', 'messages', 'finances', 'shipping', 'taxation', 'billing', 'products', 'categories', 'orders', 'settings', 'team'],
      [StaffRole.FULFILLMENT]: ['admin', 'orders', 'shipping', 'products', 'categories'],
      [StaffRole.SUPPORT]: ['admin', 'messages', 'reviews']
    };

    return permissions[staffRole].includes(pageId);
  }
};
